import React, {memo} from 'react';
import {Box, Paper, Skeleton} from '@mui/material';
import {styled} from "@mui/material/styles";

const LocationSearchListRadius = styled(Skeleton)(() => ({
  borderRadius: '1.5em',
}));

const LocationSearchListFlex = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1em',
  padding: '1em',
  borderBottom: '1px solid #E9E9FB'
}));

const LocationSearchListFullWidth = styled(Box)(() => ({
  flex: 1
}));

const LocationSearchListBottomContent = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

const LocationSearchListContainer = styled(Paper)(({theme}) => ({
  backgroundColor: '#FBFBFF',
  [theme.breakpoints.down('lg')]: {
    width: '100%'
  },
}));

interface LocationSearchListContentSkeletonProps {
    items?: number;
}

const LocationSearchListContentSkeleton = ({items = 4}: LocationSearchListContentSkeletonProps) => {
    return (
      <>{[...Array(items).keys()].map((_, index) => {
          return <LocationSearchListContainer square key={index}>
              <LocationSearchListFlex>
                  <LocationSearchListRadius variant="rectangular" width={259} height={159} />
                  <LocationSearchListFullWidth>
                      <Skeleton width={'30%'} height={30} />
                      <Skeleton variant='text' />
                      {[...Array(3).keys()].map((_, index) => <Skeleton width={'50%'} key={index} />)}
                      <LocationSearchListBottomContent>
                          {[...Array(2).keys()].map((_, index) => <Skeleton width={'30%'} key={index} />)}
                      </LocationSearchListBottomContent>
                  </LocationSearchListFullWidth>
              </LocationSearchListFlex>
          </LocationSearchListContainer>
      })}</>
    );
};

export default memo(LocationSearchListContentSkeleton);
